import Vue from "vue";
import Element from "element-ui";
import "../scss/element-variables.scss";

Vue.use(Element);
